export interface PlpBreadcrumbItem {
  label: string;
  /** Omit for current page segment */
  to?: string;
  /** Force a hard page reload when navigating (for pages outside the SPA) */
  shouldRefresh?: boolean;
}

/** Human-readable label from URL tag segment (e.g. `rings` → `Rings`). */
export function formatPlpCategoryLabel(tag: string): string {
  const t = tag.replace(/\.html?$/i, '').trim();
  if (!t) return 'Jewellery';
  return t
    .split(/[-_/]/)
    .filter(Boolean)
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase())
    .join(' ');
}

/**
 * Breadcrumbs for jewellery browse PLP routes (not store catalog).
 * Example: `/jewellery/rings.html` → Home / Jewellery / Rings
 */
export function getJewelleryBrowseBreadcrumbs(
  pathname: string,
  categoryLabel: string
): PlpBreadcrumbItem[] {
  const path = pathname.split('?')[0].replace(/\.html?$/i, '');
  const isJewelleryRoot = path === '/jewellery' || path === '/jewellery/';

  if (isJewelleryRoot) {
    return [{ label: 'Home', to: '/' }, { label: 'Jewellery' }];
  }

  const items: PlpBreadcrumbItem[] = [
    { label: 'Home', to: '/' },
    { label: 'Jewellery', to: '/jewellery.html' },
  ];

  const label = categoryLabel.trim();
  if (label.length === 0) return items;

  if (label.toLowerCase() !== 'jewellery') {
    items.push({ label });
  }

  return items;
}
